<template>
  <gj-modal
    :visible.sync="modalVisible"
    size="auto"
    width="600px"
    @cancel="cancel"
    @confirm="confirm"
    :confirm-loading="confirmLoading"
  >
    <template #header>
      <span>快速生成SKU</span>
    </template>
    <template #content>
      <p class="msg">
        <span>!</span> 快速生成的SKU产品类型均为普通产品，如需关联组合产品，请先在产品资料中维护
      </p>
      <el-form :model="form" ref="form" class="gj-form link-product" label-width="60px">
        <el-form-item
          prop="sku"
          label="SKU"
          :rules="[{ required: true, message: '请输入SKU', trigger: 'blur' }]"
        >
          <gj-input :width="inputWidth" v-model="form.sku" placeholder="请输入SKU"> </gj-input>
        </el-form-item>
        <el-form-item prop="productName" label="产品名称">
          <gj-input :width="inputWidth" v-model="form.productName" placeholder="请输入产品名称">
          </gj-input>
        </el-form-item>
        <el-form-item prop="categoryId" label="品类">
          <gj-all-category-select
            :multiple="true"
            :width="inputWidth"
            v-model="form.categoryId"
            placeholder="品类"
            :active="false"
          ></gj-all-category-select>
          <i
            class="el-icon-setting"
            v-if="$permission('category:edit')"
            style="margin-left: 10px; font-size: 16px"
            @click="toCategory"
          ></i>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, queryMixin } from '@/minxins';
import { relateOtherProduct,otherLinkProduct } from '@/api/sale';

export default {
  name: 'app-relate-product-modal',
  mixins: [modalMixIn, queryMixin],
  props: {
    id: [String, Number],
    msku: [String, Number],
    commonQueryDTOS: null,
    marketId:[String, Number],
    ids: null,
    newCompatibilityApi:{
      type:Boolean,
      default:false
    }
  },
  created() {
    this.form.sku = this.msku
  },
  data() {
    return {
      inputWidth: '450px',
      form: {
        sku: '',
        productName: '',
        categoryId: '',
      },
    };
  },
  methods: {
    toCategory() {
      this.$router.push('/product/product-category');
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          let params = {
            ...this.form,
            type: 'quick',
            id: this.id,
            marketId:this.marketId,
            msku:this.msku,
            categoryId: Array.isArray(this.form.categoryId) ? this.form.categoryId[0] : '',
            commonQueryDTOS: this.commonQueryDTOS,
          };
          let promise = null
          if (this.newCompatibilityApi) {
            promise = otherLinkProduct(params)
          }else{
            promise = relateOtherProduct(params)
          }
          promise
            .then(() => {
              this.$gjMessage.success('操作成功');
              this.$emit('after');
            })
            .complete(() => (this.confirmLoading = false));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-product{
  /deep/ .el-form-item{
    margin-bottom: 20px;
  }
}
.msg {
  margin-top: 0 !important;
  background: #fff5ed;
  border: 1px solid #f6bb90;
  box-sizing: border-box;
  border-radius: 2px;
  font-size: 12px;
  padding: 10px 0;
  margin-bottom: 20px;
  padding-left: 12px;
  span {
    text-align: center;
    background: #ed6a0c;
    /* padding: 5px; */
    width: 15px;
    height: 15px;
    display: inline-block;
    border-radius: 50%;
    color: white;
    font-weight: 800;
    line-height: 15px;
  }
}
/deep/ .vxe-table--body-wrapper {
  overflow-x: hidden !important;
}
/deep/ .el-dialog__body {
  padding-top: 12px;
}
</style>
